module.exports = __webpack_public_path__ + "static/img/ng_button.e85a9b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ng_button.png
// module id = RVGt
// module chunks = 3